import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { distinctUntilChanged, map, Observable, of, switchMap } from 'rxjs';
import { ImageChatMessageState, ImageChatMessageStoreModel, ImageChatMessageUIModel } from '../models';
import { ImageChatMessageStore } from './image-chat-message.store';

@Injectable({ providedIn: 'root' })
export class ImageChatMessageQuery extends QueryEntity<
  ImageChatMessageState,
  ImageChatMessageStoreModel,
  ImageChatMessageUIModel,
  'id'
> {
  constructor(imageChatMessageStore: ImageChatMessageStore) {
    super(imageChatMessageStore);
  }

  selectMessagesByContentJsonPath(contentJsonPath: string): Observable<ImageChatMessageStoreModel[]> {
    return this.selectProp('imageIndexToChatId').pipe(
      map((imageIndexToChatId) => imageIndexToChatId[contentJsonPath]),
      map((imageIndexPropData) => (imageIndexPropData ? imageIndexPropData.chatId : null)),
      distinctUntilChanged(),
      switchMap((chatId) =>
        chatId ? this.selectAllEntities({ filterEntity: (entity) => entity.llm_chat_id === chatId }) : of([]),
      ),
    );
  }

  selectChatIsLoadingResponse(contentJsonPath: string): Observable<boolean> {
    return this.selectProp('imageIndexToChatId').pipe(
      map((imageIndexToChatId) => imageIndexToChatId[contentJsonPath]),
      map((imageIndexPropData) => (imageIndexPropData ? imageIndexPropData.requestId !== null : false)),
      distinctUntilChanged(),
    );
  }

  selectIsChatCreated(contentJsonPath: string): Observable<boolean> {
    return this.selectProp('imageIndexToChatId').pipe(
      map((imageIndexToChatId) => imageIndexToChatId[contentJsonPath]),
      map((imageIndexPropData) => (imageIndexPropData ? imageIndexPropData.chatId !== null : false)),
      distinctUntilChanged(),
    );
  }
}
